import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastProvider } from './contexts/ToastContext';
import AuthGuard from './components/auth/AuthGuard';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import NotificationContainer from './components/notifications/NotificationContainer';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ContentPage from './pages/ContentPage';
import ProfileView from './components/profile/ProfileView';
import ProfileEdit from './components/profile/ProfileEdit';
import ChangePassword from './components/profile/ChangePassword';
import Community from './components/community/Community';
import AboutPage from './pages/AboutPage';
import CodeOfConductPage from './pages/CodeOfConductPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import GettingStartedPage from './pages/GettingStartedPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ContactPage from './pages/ContactPage';
import SupportPage from './pages/SupportPage';
import AdminPanel from './pages/AdminPanel';

function CommunityPage() {
  return (
    <div className="page">
      <div className="container">
        <Community />
      </div>
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="page">
      <div className="container">
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist.</p>
        <a href="/" className="btn btn-primary">Go Home</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <div className="app">
              <a href="#main-content" className="skip-link">
                Skip to main content
              </a>
              <Header />
              <NotificationContainer />
            
            <main id="main-content" className="main-content" role="main">
            <Routes>
              <Route path="/" element={<HomePage />} />
              
              {/* Auth routes - redirect if already authenticated */}
              <Route 
                path="/login" 
                element={
                  <AuthGuard requireAuth={false}>
                    <LoginPage />
                  </AuthGuard>
                } 
              />
              <Route 
                path="/register" 
                element={
                  <AuthGuard requireAuth={false}>
                    <RegisterPage />
                  </AuthGuard>
                } 
              />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              
              {/* Protected routes */}
              <Route path="/profile" element={
                <AuthGuard requireAuth={true}>
                  <ProfileView />
                </AuthGuard>
              } />
              <Route path="/profile/edit" element={
                <AuthGuard requireAuth={true}>
                  <ProfileEdit />
                </AuthGuard>
              } />
              <Route path="/profile/change-password" element={
                <AuthGuard requireAuth={true}>
                  <ChangePassword />
                </AuthGuard>
              } />
              <Route path="/users/:userId" element={<ProfileView />} />
              
              {/* Admin routes */}
              <Route path="/admin" element={
                <AuthGuard requireAuth={true}>
                  <AdminPanel />
                </AuthGuard>
              } />
              
              {/* Public routes */}
              <Route path="/content/*" element={<ContentPage />} />
              <Route path="/community" element={<CommunityPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/getting-started" element={<GettingStartedPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/support" element={<SupportPage />} />
              
              {/* Catch-all route */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          
          <Footer />
        </div>
      </Router>
        </NotificationProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;